import axios from "axios";
import GetServerAddress from "../../../../../functions/GetServerAddress";

export async function Send_GSP_Booking_Email_To_School_Contact(
  Contact,
  ChosenBooking,
  logout
) {
  let Staff = localStorage.getItem("Username");
  try {
    const response = await axios.post(
      GetServerAddress() + "api/staff/Send_GSP_Booking_Email_To_School_Contact",
      {
        Contact: Contact,
        ChosenBooking: ChosenBooking,
        Staff: Staff,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
          username: localStorage.getItem("Username"),
          activitylog: "Yes",
          aboutid: ChosenBooking._id,
        },
      }
    );
    // Check for specific server response indicating an invalid auth token
    if (response.data.status === 403 || response.data.status === 401) {
      logout();
      return; // Stop further execution in case of invalid auth token
    }

    console.log(response.data.data[0]);

    window.alert(response.data.message);
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}
